import React, { createElement } from 'react';
import { Button, Dialog, Notification } from '@alifd/next';
import request from '@/utils/request';
import { isEmpty } from 'lodash-es';
export const useActionColumnProps = (props) => {
    const { title, width, lock, align = 'center', isDesign, setEditType, setEditRow, url, openPane, refreshList, setRowRecord, setVisible, addButtonformBlocks = [], setBehavior, onRowClick, } = props;
    const edit = async (record) => {
        const id = record?.id;
        const { content } = await request.get(`${url}/${id}`);
        setEditType('edit');
        setEditRow(content);
        openPane(['1', '2']);
    };
    const view = async (record) => {
        const id = record?.id;
        const { content } = await request.get(`${url}/${id}`);
        setEditType('view');
        setEditRow(content);
        openPane(['1', '2']);
    };
    const del = React.useCallback((record) => {
        const id = record?.id;
        Dialog.confirm({
            title: '确认删除吗',
            closeMode: ['close', 'esc', 'mask'],
            onOk: async () => {
                try {
                    await request.delete(`${url}/${id}`);
                    Notification.success({
                        title: '删除成功!',
                    });
                    refreshList();
                }
                catch (error) {
                    console.error(error);
                }
            },
        });
    }, [refreshList, url]);
    const addButtonClick = (behavior, record) => {
        setRowRecord(record);
        const type = behavior?.type;
        if (type === 'dialog' || type === 'drawer') {
            setVisible(true);
        }
        setBehavior(behavior);
    };
    const renderCell = (value, rowIndex, record, context) => {
        return (createElement("div", { style: { display: 'flex', columnGap: 4, justifyContent: 'center' } },
            createElement(Button, { type: "primary", disabled: isDesign, onClick: () => {
                    view(record);
                    onRowClick(value, rowIndex, record, context);
                }, size: "small" }, "\u67E5\u770B"),
            createElement(Button, { type: "primary", disabled: isDesign, onClick: () => {
                    edit(record);
                    onRowClick(value, rowIndex, record, context);
                }, size: "small" }, "\u7F16\u8F91"),
            !isEmpty(addButtonformBlocks)
                ? addButtonformBlocks.map((item) => {
                    const { title, size, behavior } = item || {};
                    return (createElement(Button, { type: "primary", disabled: isDesign, size: size, onClick: () => addButtonClick(behavior, record) }, title));
                })
                : null,
            createElement(Button, { warning: true, disabled: isDesign, onClick: () => del(record), size: "small" }, "\u5220\u9664")));
    };
    return { title, width, lock, cell: renderCell, align };
};
